var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ButtonComponent',{staticClass:"kvass-media-types-vimeo-create-trigger",attrs:{"type":"button"}},[_c('span',[_vm._v("Vimeo")]),_c('Icon',{staticClass:"ml-1",attrs:{"icon":['fab', 'vimeo']}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }